'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadDesignTemplateData = loadDesignTemplateData;
exports.loadContentTemplateData = loadContentTemplateData;
exports.printPDF = printPDF;
exports.loadSavedUserData = loadSavedUserData;
exports.analyzeText = analyzeText;
exports.loadVerbAlternatives = loadVerbAlternatives;
exports.uploadImage = uploadImage;
exports.highlightActionVerb = highlightActionVerb;
exports.turnOnAnalysisMode = turnOnAnalysisMode;
exports.chooseTemplate = chooseTemplate;
exports.chooseContentTemplate = chooseContentTemplate;
exports.chooseUserDataID = chooseUserDataID;
exports.clean = clean;
exports.setResumeName = setResumeName;
exports.showResumeNameModal = showResumeNameModal;
exports.showSectionEditor = showSectionEditor;
exports.showSocialEditor = showSocialEditor;
exports.showTimelineEditor = showTimelineEditor;
exports.copyBlock = copyBlock;
exports.addNewSection = addNewSection;
exports.deleteBlock = deleteBlock;
exports.updateField = updateField;
exports.updatePersonalDetails = updatePersonalDetails;
exports.sort = sort;
exports.sortDataOrder = sortDataOrder;
exports.setDesingOrder = setDesingOrder;
exports.updateInterSectionMargin = updateInterSectionMargin;
exports.updatePrimaryColor = updatePrimaryColor;
exports.updateSecondaryColor = updateSecondaryColor;
exports.updateHeaderFont = updateHeaderFont;
exports.updateBodyFont = updateBodyFont;
exports.cleanDesignTemplate = cleanDesignTemplate;
exports.cleanContentTemplate = cleanContentTemplate;
exports.isLoaded = isLoaded;

var _reactSortableHoc = require('react-sortable-hoc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOADING_TEMPLATE = 'LOADING_TEMPLATE';
var LOAD_TEMPLATE_SUCCESS = 'LOAD_TEMPLATE_SUCCESS';
var LOAD_TEMPLATE_FAIL = 'LOAD_TEMPLATE_FAIL';
var CHOOSE_DESIGN_TEMPLATE = 'CHOOSE_DESIGN_TEMPLATE';
var CHOOSE_CONTENT_TEMPLATE = 'CHOOSE_CONTENT_TEMPLATE';
var BASIC_BUILDER_PRINT_DESIGN = 'BASIC_BUILDER_PRINT_DESIGN';
var CHOOSE_USER_DATA = 'CHOOSE_USER_DATA';
var LOADING_CONTENT_TEMPLATE = 'LOADING_CONTENT_TEMPLATE';
var LOAD_CONTENT_TEMPLATE_SUCCESS = 'LOAD_CONTENT_TEMPLATE_SUCCESS';
var LOAD_CONTENT_TEMPLATE_FAIL = 'LOAD_CONTENT_TEMPLATE_FAIL';
var LOADING_SAVED_USER_DATA = 'LOAD_SAVED_USER_DATA';
var LOAD_SAVED_USER_DATA_SUCCESS = 'LOAD_SAVED_USER_DATA_SUCCESS';
var LOAD_SAVED_USER_DATA_FAIL = 'LOAD_SAVED_USER_DATA_FAIL';
var PRINTING = 'PRINTING';
var PRINTING_SUCCESS = 'PRINTING_SUCCESS';
var PRINTING_FAIL = 'PRINTING_FAIL';
var DELETE = 'templateData/DELETE';
var COPY = 'templateData/COPY';
var UPDATEFIELD = 'templateData/UPDATEFIELD';
var SORT = 'templateData/SORT';
var SORT_DESIGN_ORDER = 'templateData/SORT_DESIGN_ORDER';
var DESIGN_ORDER_ADD = 'templateData/DESIGN_ORDER_ADD';
var UPDATE_PERSONAL_FIELD = 'templateData/UPDATE_PERSONAL_FIELD';
var UPDATE_INTER_SECTION_MARGIN = 'templateData/UPDATE_INTER_SECTION_MARGIN';
var UPDATE_PRIMARY_COLOR = 'templateData/UPDATE_PRIMARY_COLOR';
var UPDATE_SECONDARY_COLOR = 'templateData/UPDATE_SECONDARY_COLOR';
var UPDATE_HEADER_FONT = 'templateData/UPDATE_HEADER_FONT';
var UPDATE_BODY_FONT = 'templateData/UPDATE_BODY_FONT';
var SET_RESUME_NAME = 'templateData/SET_RESUME_NAME';
var SET_USER_NAME = 'templateData/SET_USER_NAME';
var SET_USER_EMAIL = 'templateData/SET_USER_EMAIL';
var SET_USER_PHONE = 'templateData/SET_USER_PHONE';
var SHOW_RESUME_NAME_MODAL = 'templateData/SHOW_RESUME_NAME_MODAL';
var SHOW_SECTION_EDITOR = 'templateData/SHOW_SECTION_EDITOR';
var ADD_NEW_SECTION = 'templateData/ADD_NEW_SECTION';
var SHOW_SOCIAL_EDITOR = 'templateData/SHOW_SOCIAL_EDITOR';
var SHOW_TIMELINE_EDITOR = 'templateData/SHOW_TIMELINE_EDITOR';
var CLEAN = 'CLEAN';
var ANALYZE_TEXT = 'templateData/ANALYZE_TEXT';
var ANALYZE_TEXT_SUCCESS = 'templateData/ANALYZE_TEXT_SUCCESS';
var ANALYZE_TEXT_FAIL = 'templateData/ANALYZE_TEXT_FAIL';
var HIGHLIGHT_ACTION_VERB = 'templateData/HIGHLIGHT_ACTION_VERB';
var LOAD_VERB_ALTERNATIVES = 'templateData/LOAD_VERB_ALTERNATIVES';
var LOAD_VERB_ALTERNATIVES_SUCCESS = 'templateData/LOAD_VERB_ALTERNATIVES_SUCCESS';
var LOAD_VERB_ALTERNATIVES_FAIL = 'templateData/LOAD_VERB_ALTERNATIVES_FAIL';
var TURN_ON_ANALYSIS_MODE = 'templateData/TURN_ON_ANALYSIS_MODE';
var UPLOAD_IMAGE = 'templateData/UPLOAD_IMAGE';
var UPLOAD_IMAGE_SUCCESS = 'templateData/UPLOAD_IMAGE_SUCCESS';
var UPLOAD_IMAGE_FAIL = 'templateData/UPLOAD_IMAGE_FAIL';
var CLEAN_DESIGN_TEMPLATE = 'templateData/CLEAN_DESIGN_TEMPLATE';
var CLEAN_CONTENT_TEMPLATE = 'templateData/CLEAN_CONTENT_TEMPLATE';

var initialState = {
  show_resume_name_modal: false,
  show_section_editor: false,
  show_social_editor: false,
  show_timeline_editor: false,
  resume_name: false,
  design_template_id: false,
  design_template_data: false,
  content_template_id: false,
  user_data_id: false,
  content_template_data: false,
  loading_design: false,
  loading_content: false,
  design_order: false,
  info_block: false,
  personal_info: false,
  printing: false,
  printing_success: false,
  inter_section_margin: false,
  primary_color: false,
  secondary_color: false,
  header_font: false,
  body_font: false,
  text_analysis_data: false,
  analyzing_text: false,
  highlighted_action_verb: false,
  verb_alternatives: false,
  loading_verb_alternatives: false,
  analysis_mode_on: false,
  uploading_image: false,
  uploaded_image_url: false,
  uploaded_image_index: false,
  resume_review_id: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_RESUME_NAME:
      return (0, _extends3.default)({}, state, {
        resume_name: action.data
      });
    case SHOW_RESUME_NAME_MODAL:
      return (0, _extends3.default)({}, state, {
        show_resume_name_modal: action.data
      });
    case SHOW_SECTION_EDITOR:
      return (0, _extends3.default)({}, state, {
        show_section_editor: action.data
      });
    case SHOW_SOCIAL_EDITOR:
      return (0, _extends3.default)({}, state, {
        show_social_editor: action.data
      });
    case SHOW_TIMELINE_EDITOR:
      return (0, _extends3.default)({}, state, {
        show_timeline_editor: action.data
      });
    case CHOOSE_DESIGN_TEMPLATE:
      if (action.initialize) {
        initialState.design_template_id = action.id;
      }
      return (0, _extends3.default)({}, state, {
        design_template_id: action.id
      });
    case CLEAN_DESIGN_TEMPLATE:
      return (0, _extends3.default)({}, state, {
        design_template_id: false
      });
    case CLEAN_CONTENT_TEMPLATE:
      return (0, _extends3.default)({}, state, {
        constent_template_id: false
      });
    case SET_USER_NAME:
      if (action.initialize) {
        initialState.user_name = action.id;
      }
      return (0, _extends3.default)({}, state);
    case SET_USER_EMAIL:
      if (action.initialize) {
        initialState.user_email = action.id;
      }
      return (0, _extends3.default)({}, state);
    case SET_USER_PHONE:
      if (action.initialize) {
        initialState.user_phone = action.id;
      }
      return (0, _extends3.default)({}, state);
    case CHOOSE_CONTENT_TEMPLATE:
      if (action.initialize) {
        initialState.content_template_id = action.id;
      }
      return (0, _extends3.default)({}, state, {
        content_template_id: action.id
      });
    case BASIC_BUILDER_PRINT_DESIGN:
      if (action.initialize) {
        initialState.basic_builder_print_design = action.id;
      }
      return (0, _extends3.default)({}, state, {
        basic_builder_print_design: action.id
      });
    case CHOOSE_USER_DATA:
      return (0, _extends3.default)({}, state, {
        user_data_id: action.id
      });
    case LOADING_TEMPLATE:
      return (0, _extends3.default)({}, state, {
        loading_design: true
      });
    case LOAD_TEMPLATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        design_template_id: action.result.id,
        design_template_name: action.result.name,
        design_template_data: action.result.data,
        design_template_free: action.result.free,
        inter_section_margin: action.result.inter_section_margin,
        primary_color: action.result.primary_color,
        secondary_color: action.result.secondary_color,
        header_font: action.result.header_font,
        body_font: action.result.body_font,
        resume_review_id: action.result.resume_review ? action.result.resume_review.id : null,
        loading_design: false,
        loaded_design: true
      });
    case LOAD_TEMPLATE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading_design: false,
        loaded_design: false
      });
    case PRINTING:
      return (0, _extends3.default)({}, state, {
        printing: true,
        printing_success: false
      });
    case PRINTING_SUCCESS:
      // console.log(action);
      //var w=window.open(action.result.path, '_blank');
      // var printWindow = window.open(action.result.path);
      // w.focus();
      // window.open(TARGET_URL + action.result.path, '_blank');
      return (0, _extends3.default)({}, state, {
        printing_success: true,
        printing: false,
        print_url: action.result.path,
        print_data: action.result.data
      });
    case PRINTING_FAIL:
      return (0, _extends3.default)({}, state, {
        printing: false,
        printing_success: false

      });
    case LOADING_CONTENT_TEMPLATE:
      return (0, _extends3.default)({}, state, {
        loading_content: true
      });
    case LOAD_CONTENT_TEMPLATE_SUCCESS:
      // Converting the array recieved from server to relevant object
      // Format is {'PR': [], 'MI': []}
      var load_info = action.result.info_block;
      var info_block = {};
      for (var key in load_info) {
        if (info_block[load_info[key].type]) {
          info_block[load_info[key].type].push(load_info[key]);
        } else {
          info_block[load_info[key].type] = [load_info[key]];
        }
      }
      var personal_info = action.result.personal_info;
      if (initialState.user_name) {
        personal_info.name = initialState.user_name;
      }
      if (initialState.user_email) {
        personal_info.email = initialState.user_email;
      }
      if (initialState.user_phone) {
        personal_info.phone = initialState.user_phone;
      }

      return (0, _extends3.default)({}, state, {
        content_template_id: action.result.id,
        info_block: info_block,
        personal_info: personal_info,
        content_template_name: action.result.name,
        content_template_free: action.result.free,
        content_template_data: true,
        loading_content: false,
        loaded_content: true
      });
    case LOAD_CONTENT_TEMPLATE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading_content: false,
        loaded_content: false
      });
    case LOADING_SAVED_USER_DATA:
      return (0, _extends3.default)({}, state, {
        loading_content: true
      });
    case LOAD_SAVED_USER_DATA_SUCCESS:
      // Converting the array recieved from server to relevant object
      // Format is {'PR': [], 'MI': []}
      var canvas = document.createElement("canvas");
      var context = canvas.getContext('2d');
      var base_image = new Image();
      var newdata;
      base_image.setAttribute('crossOrigin', 'anonymous');
      base_image.src = action.result.personal_info.image;
      // base_image.onload = () => {
      //   context.drawImage(base_image, 100, 100);
      //   newdata = canvas.toDataURL("image/jpeg");
      //   action.result.personal_info.image = newdata;
      //   }
      var info = action.result.info_block;

      var info_block = {};
      for (var key in info) {
        if (info_block[info[key].type]) {
          info_block[info[key].type].push(info[key]);
        } else {
          info_block[info[key].type] = [info[key]];
        }
      }

      var design_order = false;
      if (action.result.design_order && !(action.result.design_order === 'false')) {
        design_order = action.result.design_order.replace(/\s/g, '').split(',');
      }
      if (!state.design_template_id && !state.design_template_name) {
        console.log("entered");
        return (0, _extends3.default)({}, state, {
          user_data_id: action.result.id,
          info_block: info_block,
          personal_info: action.result.personal_info,
          design_order: design_order,
          content_template_id: action.result.content_template.id,
          content_template_name: action.result.content_template.name,
          content_template_free: action.result.content_template.free,
          inter_section_margin: action.result.inter_section_margin,
          primary_color: action.result.primary_color,
          secondary_color: action.result.secondary_color,
          header_font: action.result.header_font,
          body_font: action.result.body_font,
          content_template_data: true,
          user_data: true,
          loading_content: false,
          loaded_content: true,
          design_template_id: action.result.design_template.id,
          design_template_name: action.result.design_template.name,
          design_template_data: action.result.design_template.data,
          design_template_free: action.result.design_template.free,
          resume_review_id: action.result.resume_review ? action.result.resume_review.id : null,
          loading_design: false,
          loaded_design: true,
          resume_name: action.result.name_of_template
        });
      } else {
        return (0, _extends3.default)({}, state, {
          user_data_id: action.result.id,
          info_block: info_block,
          personal_info: action.result.personal_info,
          design_order: design_order,
          content_template_id: action.result.content_template.id,
          content_template_name: action.result.content_template.name,
          content_template_free: action.result.content_template.free,
          inter_section_margin: action.result.inter_section_margin,
          primary_color: action.result.primary_color,
          secondary_color: action.result.secondary_color,
          header_font: action.result.header_font,
          resume_review_id: action.result.resume_review ? action.result.resume_review.id : null,
          body_font: action.result.body_font,
          content_template_data: true,
          user_data: true,
          loading_content: false,
          loaded_content: true
        });
      }

    case LOAD_SAVED_USER_DATA_FAIL:
      return (0, _extends3.default)({}, state, {
        loading_content: false,
        loaded_content: false
      });
    case CLEAN:
      // console.log(initialState);
      return initialState;
    case COPY:
      var copy_info_block = state.info_block;
      var object = JSON.parse((0, _stringify2.default)(copy_info_block[action.data_parent][action.index]));
      object['id'] = action.id;
      copy_info_block[action.data_parent] = copy_info_block[action.data_parent].concat(object);
      return (0, _extends3.default)({}, state, {
        info_block: copy_info_block
      });
    case DELETE:
      var delete_state = state;
      var delete_info_block = delete_state.info_block;
      delete_info_block[action.data_parent].splice(action.index, 1);
      return (0, _extends3.default)({}, state, {
        info_block: delete_info_block
      });
    case UPDATEFIELD:
      var field = action.field;
      var object = state.info_block[action.data_parent][action.index];
      object[field] = action.data;
      state.info_block[action.data_parent][action.index] = object;
      return state;
    case SORT:
      var move_info_block = state.info_block;
      move_info_block[action.data_parent] = (0, _reactSortableHoc.arrayMove)(move_info_block[action.data_parent], action.oldIndex, action.newIndex);
      return (0, _extends3.default)({}, state, {
        info_block: move_info_block
      });
    case SORT_DESIGN_ORDER:
      var sort_design_order = state.design_order;
      sort_design_order = (0, _reactSortableHoc.arrayMove)(state.design_order, action.oldIndex, action.newIndex);
      // state.design_order = arrayMove(state.design_order, action.oldIndex, action.newIndex);
      return (0, _extends3.default)({}, state, {
        design_order: sort_design_order
      });
    case DESIGN_ORDER_ADD:
      state.design_order = action.data;
      return state;
    case UPDATE_PERSONAL_FIELD:
      var single_field = action.field;
      var object = state.personal_info;
      object[single_field] = action.data;
      state.personal_info = object;
      return state;
    case UPDATE_INTER_SECTION_MARGIN:
      return (0, _extends3.default)({}, state, {
        inter_section_margin: action.data
      });
    case UPDATE_PRIMARY_COLOR:
      return (0, _extends3.default)({}, state, {
        primary_color: action.data
      });
    case UPDATE_SECONDARY_COLOR:
      return (0, _extends3.default)({}, state, {
        secondary_color: action.data
      });
    case UPDATE_HEADER_FONT:
      return (0, _extends3.default)({}, state, {
        header_font: action.data
      });
    case UPDATE_BODY_FONT:
      return (0, _extends3.default)({}, state, {
        body_font: action.data
      });
    case TURN_ON_ANALYSIS_MODE:
      if (!action.data) {
        return (0, _extends3.default)({}, state, {
          analysis_mode_on: action.data,
          text_analysis_data: false
        });
      }
      return (0, _extends3.default)({}, state, {
        analysis_mode_on: action.data
      });
    case ANALYZE_TEXT:
      return (0, _extends3.default)({}, state, {
        analyzing_text: true
      });
    case ANALYZE_TEXT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        text_analysis_data: action.result.data,
        analyzing_text: false
      });
    case ANALYZE_TEXT_FAIL:
      return (0, _extends3.default)({}, state, {
        analyzing_text: false
      });
    case LOAD_VERB_ALTERNATIVES:
      return (0, _extends3.default)({}, state, {
        loading_verb_alternatives: true
      });
    case LOAD_VERB_ALTERNATIVES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        verb_alternatives: action.result.data,
        loading_verb_alternatives: false
      });
    case LOAD_VERB_ALTERNATIVES_FAIL:
      return (0, _extends3.default)({}, state, {
        loading_verb_alternatives: false,
        verb_alternatives: false
      });
    case UPLOAD_IMAGE:
      return (0, _extends3.default)({}, state, {
        uploading_image: true
      });
    case UPLOAD_IMAGE_SUCCESS:
      if (action.result.success) {
        return (0, _extends3.default)({}, state, {
          uploaded_image_url: action.result.url,
          uploaded_image_index: action.result.image_index,
          uploading_image: false
        });
      }
    case UPLOAD_IMAGE_FAIL:
      return (0, _extends3.default)({}, state, {
        uploaded_image_url: false,
        uploading_image: false
      });
    case HIGHLIGHT_ACTION_VERB:
      return (0, _extends3.default)({}, state, {
        highlighted_action_verb: action.data
      });
    case ADD_NEW_SECTION:
      var new_section_info_block = {};
      new_section_info_block[action.data.type] = [action.data];
      var combined_info_block = (0, _extends3.default)({}, state.info_block, new_section_info_block);
      return (0, _extends3.default)({}, state, {
        info_block: combined_info_block
      });
      break;
    default:
      return state;
  }
}

function loadDesignTemplateData(id) {
  return {
    types: [LOADING_TEMPLATE, LOAD_TEMPLATE_SUCCESS, LOAD_TEMPLATE_FAIL],
    promise: function promise(client) {
      return client.get('/load-design-template/' + id + '/');
    }
  };
}

function loadContentTemplateData(id) {
  return {
    types: [LOADING_CONTENT_TEMPLATE, LOAD_CONTENT_TEMPLATE_SUCCESS, LOAD_CONTENT_TEMPLATE_FAIL],
    promise: function promise(client) {
      return client.get('/load-content-template/' + id + '/');
    }
  };
}

function printPDF(data) {
  return {
    types: [PRINTING, PRINTING_SUCCESS, PRINTING_FAIL],
    promise: function promise(client) {
      return client.post('/print-pdf/', { data: data });
    }
  };
}

// This is not used anywhere check and remove. Actual function in saveUserData.js
function loadSavedUserData(id) {
  var slug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var url;
  if (slug) {
    url = '/load-save-user-data/';
  } else {
    url = '/load-saved-user-data/';
  }
  return {
    types: [LOADING_SAVED_USER_DATA, LOAD_SAVED_USER_DATA_SUCCESS, LOAD_SAVED_USER_DATA_FAIL],
    promise: function promise(client) {
      return client.get(url + id + '/');
    }
  };
}

function analyzeText(data) {
  return {
    types: [ANALYZE_TEXT, ANALYZE_TEXT_SUCCESS, ANALYZE_TEXT_FAIL],
    promise: function promise(client) {
      return client.post('/text-analysis/', { data: data });
    }
  };
}

function loadVerbAlternatives(data) {
  return {
    types: [LOAD_VERB_ALTERNATIVES, LOAD_VERB_ALTERNATIVES_SUCCESS, LOAD_VERB_ALTERNATIVES_FAIL],
    promise: function promise(client) {
      return client.get('/get-verb-alternatives/?verb=' + data);
    }
  };
}

function uploadImage(data) {
  return {
    types: [UPLOAD_IMAGE, UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAIL],
    promise: function promise(client) {
      return client.post('/upload-s3/', { data: data });
    }
  };
}

function highlightActionVerb(verb) {
  return {
    type: HIGHLIGHT_ACTION_VERB,
    data: verb
  };
}

function turnOnAnalysisMode(data) {
  return {
    type: TURN_ON_ANALYSIS_MODE,
    data: data
  };
}

function chooseTemplate(id) {
  return {
    type: CHOOSE_DESIGN_TEMPLATE,
    id: id,
    initialize: false
  };
}

function chooseContentTemplate(id) {
  return {
    type: CHOOSE_CONTENT_TEMPLATE,
    id: id,
    initialize: false
  };
}

function chooseUserDataID(id) {
  return {
    type: CHOOSE_USER_DATA,
    id: id
  };
}

function clean() {
  return {
    type: CLEAN
  };
}

function setResumeName(name) {
  return {
    type: SET_RESUME_NAME,
    data: name
  };
}

function showResumeNameModal(value) {
  return {
    type: SHOW_RESUME_NAME_MODAL,
    data: value
  };
}

function showSectionEditor(value) {
  return {
    type: SHOW_SECTION_EDITOR,
    data: value
  };
}

function showSocialEditor(value) {
  return {
    type: SHOW_SOCIAL_EDITOR,
    data: value
  };
}

function showTimelineEditor(value) {
  return {
    type: SHOW_TIMELINE_EDITOR,
    data: value
  };
}

function copyBlock(index, new_id, data_parent) {
  return {
    type: COPY,
    index: index,
    id: new_id,
    data_parent: data_parent
  };
}

function addNewSection(data) {
  return {
    type: ADD_NEW_SECTION,
    data: data
  };
}

function deleteBlock(index, data_parent) {
  return {
    type: DELETE,
    index: index,
    data_parent: data_parent
  };
}

function updateField(data, index, field, data_parent) {
  return {
    type: UPDATEFIELD,
    index: index,
    data: data,
    field: field,
    data_parent: data_parent
  };
}

function updatePersonalDetails(data, field) {
  return {
    type: UPDATE_PERSONAL_FIELD,
    data: data,
    field: field
  };
}

function sort(oldIndex, newIndex, data_parent) {
  return {
    type: SORT,
    oldIndex: oldIndex,
    newIndex: newIndex,
    data_parent: data_parent
  };
}

function sortDataOrder(oldIndex, newIndex) {
  return {
    type: SORT_DESIGN_ORDER,
    oldIndex: oldIndex,
    newIndex: newIndex
  };
}

function setDesingOrder(data) {
  return {
    type: DESIGN_ORDER_ADD,
    data: data
  };
}

function updateInterSectionMargin(data) {
  return {
    type: UPDATE_INTER_SECTION_MARGIN,
    data: data
  };
}

function updatePrimaryColor(data) {
  return {
    type: UPDATE_PRIMARY_COLOR,
    data: data
  };
}

function updateSecondaryColor(data) {
  return {
    type: UPDATE_SECONDARY_COLOR,
    data: data
  };
}

function updateHeaderFont(data) {
  return {
    type: UPDATE_HEADER_FONT,
    data: data
  };
}

function updateBodyFont(data) {
  return {
    type: UPDATE_BODY_FONT,
    data: data
  };
}

function cleanDesignTemplate() {
  return {
    type: CLEAN_DESIGN_TEMPLATE
  };
}

function cleanContentTemplate() {
  return {
    type: CLEAN_CONTENT_TEMPLATE
  };
}

function isLoaded(globalState) {
  return globalState.templateData && globalState.templateData.loaded;
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/templateData.js
// module id = 25
// module chunks = 0